import {faArrowUpRightFromSquare} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {NavGroupProps, NavItemDataProps} from '@minimal/components/nav-section';
import {getLinkByEnv} from '@workspaces/link';
import {appLinks} from '@workspaces/nemesis';

export const externalLink: NavItemDataProps = {
  title: 'menu.external.go-to-app',
  path: getLinkByEnv(appLinks),
  icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
};

export const menu: NavGroupProps[] = [
  {
    items: [externalLink],
  },
];
